import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { TimeoutError, throwError, timer } from 'rxjs';
import { retry, timeout } from 'rxjs/operators';

import { RETRY_ON_TIMEOUT } from './retry-timeout.config';

const DEFAULT_MAX_RETRIES = 2;
const DEFAULT_RETRY_DELAY_MS = 1000;

export const retryOnTimeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const config = req.context.get(RETRY_ON_TIMEOUT);

  // need to be explicitly enabled in order to retry "timed out" requests
  if (!config?.retryTimeoutEnabled) return next(req);

  // customizable per request
  const maxRetries = config?.maxRetries ?? DEFAULT_MAX_RETRIES;
  const retryDelayMs = config?.retryDelayMs ?? DEFAULT_RETRY_DELAY_MS;

  return next(req).pipe(
    retry({
      count: maxRetries,
      delay: error => {
        // detect and retry 504 errors
        if (error?.status === HttpStatusCode.GatewayTimeout) return timer(retryDelayMs);

        // throw error on every other error type
        return throwError(() => error);
      },
    }),
  );
};
